<template>
  <div class="indicators-form default-form">
    <ValidationObserver ref="form">
      <div class="columns">
        <div class="column">
          <div class="row">
            <validation-provider name="Название" rules="required">
              <template #default="{ errors }">
                <label>Название</label>
                <input
                  type="text"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0] }"
                  v-model="model.title"
                  placeholder="Название"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Статус" rules="required">
              <template #default="{ errors }">
                <label>Статус</label>
                <multiselect
                  v-model="model.status"
                  :options="statuses"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0] }"
                  track-by="id"
                  label="title"
                  placeholder="Статус"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Категория" rules="required">
              <template #default="{ errors }">
                <label>Категория</label>
                <multiselect
                  v-model="model.type"
                  :options="categories"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0] }"
                  track-by="id"
                  label="title"
                  placeholder="Категория"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <label>Кнопка действия</label>
            <multiselect
              v-model="model.action_button"
              :options="actions"
              :disabled="readOnly"
              :class="{ 'form-error': errors[0] }"
              track-by="id"
              label="title"
              placeholder="Кнопка с действием"
            />
          </div>
        </div>

        <div class="column img">
          <div class="row">
            <validation-provider name="Изображение" rules="required">
              <template #default="{ errors }">
                <label>Изображение</label>
                <vue-dropzone
                  id="dropzone"
                  ref="imageDropzone"
                  v-model="model.image_url"
                  :options="dropzoneOptions"
                  :destroyDropzone="false"
                  :class="{ 'form-error': errors[0] }"
                  @vdropzone-success="success"
                  @vdropzone-mounted="dropzoneMounted"
                  @vdropzone-removed-file="dropzoneFileRemoved"
                  @vdropzone-file-added="dropzoneAdded"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="row">
        <label>Описание</label>
        <textarea
          v-model="model.description"
          :disabled="readOnly"
          rows="10"
          placeholder="Описание"
        />
      </div>

      <div class="row">
        <label>Комментарий</label>
        <textarea
          v-model="model.comment"
          :disabled="readOnly"
          rows="10"
          placeholder="Комментарий"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';

import { mapActions, mapGetters } from 'vuex';

import options from '@/config/dropzone-options';

import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'indicators-form',

  components: {
    vueDropzone: vue2Dropzone,
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    model: Object,
  },

  computed: {
    ...mapGetters({
      statuses: 'indicators/statuses',
      categories: 'indicators/categories',
      actions: 'indicators/actions',
      uploadResponse: 'util/uploadResponse',
    }),

    dropzoneOptions() {
      return {
        ...options,
        url: `${process.env.VUE_APP_STATIC_URL}audi`,
        addRemoveLinks: true,
      };
    },

    readOnly() {
      return !!this.model.deleted_at;
    },
  },

  methods: {
    ...mapActions({
      uploadStaticFile: 'util/uploadStaticFile',
      removeStaticFile: 'util/removeStaticFile',
    }),

    async dropzoneAdded(file) {
      if (!file.manuallyAdded) {
        const formData = new FormData();
        formData.append('file', file);

        await this.uploadStaticFile({
          formData,
          listener: this.updateProgress,
          file,
        });

        file.url = this.getUrlByFileName(this.uploadResponse.data.data.name);

        this.$refs.imageDropzone.dropzone
          .emit('complete', file)
          .emit('success', file, this.uploadResponse);
      }
    },

    updateProgress(event, file) {
      const percentCompleted = Math.floor((event.loaded * 100) / event.total);

      this.$refs.imageDropzone.dropzone.emit('uploadprogress', file, percentCompleted);
    },

    success(file, response) {
      const url = process.env.VUE_APP_CDN_STATIC_URL + response.data.data.name;
      this.$emit('imageUploaded', url);
    },

    async validate() {
      return await this.$refs.form.validate();
    },

    async dropzoneFileRemoved(file) {
      const url = this.extractUrl(file);
      if (url) {
        await this.removeStaticFile(url);
        this.$emit('imageDeleted', url);
      } else {
        // console.warn('No image to delete');
      }
    },

    extractUrl(file) {
      if (file.url) {
        return file.url;
      } else {
        if (file.xhr) {
          if (file.xhr.response) {
            const response = JSON.parse(file.xhr.response);
            return response.data ? this.getUrlByFileName(response.data.name) : false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },

    getUrlByFileName(name) {
      return process.env.VUE_APP_STATIC_URL + name;
    },

    dropzoneMounted() {
      if (this.model.image_url) {
        this.addFileByUrl(this.model.image_url);
      }
    },

    addFileByUrl(url) {
      this.$refs.imageDropzone.manuallyAddFile(
        {
          url,
          size: null,
          name: url,
        },
        url
      );
    },
  },
};
</script>
